import CookieAnalyticsManager from '../../CookieBannerManager/CookieAnalyticsManager';

export default async () => {
  const isEnabled = await new CookieAnalyticsManager().getInitialValue();

  return !!isEnabled;
};
